export default __webpack_public_path__ + "static/media/back-white.962720b1.svg";